import imageFragment from "./image";
import seoFragment from "./seo";

export const productFragment = /* GraphQl */ `
    fragment product on Product {
    id
    handle
    availableForSale
    title
    description
    descriptionHtml
    options { id name values }
    priceRange {
      maxVariantPrice { amount currencyCode }
      minVariantPrice { amount currencyCode }
    }
    variants(first: 250) {
      edges { node {
        id
        title
        availableForSale
        selectedOptions { name value }
        price { amount currencyCode }
        quantityAvailable
      } }
    }
    featuredImage { ...image }
    images(first: 20) { edges { node { ...image } } }
    seo { ...seo }
    tags
    collections(first: 5) {
      edges { node {
        title
        handle
      } }
    }
    updatedAt
    ingredients: metafield(namespace: "custom", key: "ingredients") { value }
    instructions: metafield(namespace: "custom", key: "instructions") { value }
    disclaimer: metafield(namespace: "custom", key: "disclaimer") { value }
    set_amount: metafield(namespace: "custom", key: "set_amount") { value }
    set_items: metafield(namespace: "custom", key: "set_items") { value }
    spicy_level: metafield(namespace: "custom", key: "spicy_level") { value }
    phenol_count: metafield(namespace: "custom", key: "phenol_count") { value }
    crush_date: metafield(namespace: "custom", key: "crush_date") { value }
    country_of_origin: metafield(namespace: "custom", key: "country_of_origin") { value }
    }
    ${imageFragment}
    ${seoFragment}
`;


